import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { CentroCosto } from '../models/centroCosto';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/CentrosCostos';

@Injectable({
  providedIn: 'root'
})
export class CentroCostoService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getBySociedad(code): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetBySociedad?sociedadId=' + code })
  }

  save(centroCosto: CentroCosto)
  {
    return this._http.post({ url: baseUrl + '/Save', body: centroCosto });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });   
  }
}

